// extracted by mini-css-extract-plugin
module.exports = {"input":"FieldCurrencyInput_input__2qBUS","inputSuccess":"FieldCurrencyInput_inputSuccess__3G13e","inputError":"FieldCurrencyInput_inputError__3jlzZ"};